import type { ColumnType } from "@similarweb/pro-logic-components/dist/table/utils/types";

import { translate } from "app/filters/i18nFilter";
import type { ColummListColumn } from "app/pages/sales-intelligence/common-components/search-results-table";
import type { ContactSearchEntry } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

type Column = Omit<ColummListColumn<ContactSearchEntry>, "dataIndex">;

export const createRegularContactColumn = (
    dataIndex: keyof ContactSearchEntry,
    column: Partial<Column>,
): ColumnType<ContactSearchEntry> =>
    ({
        dataIndex,
        title: translate(`si.contacts_search.table.column.${dataIndex}.title`),
        fixed: false,
        width: 190,
        sorter: false,
        ...column,
    }) as ColumnType<ContactSearchEntry>;
